import { apiFetch } from "@/lib/api";
import type { MrpPurchaseOrderDetailResponse } from "@/lib/mrp";

export const PURCHASE_ORDER_DETAIL_STALE_MS = 30_000;

export function purchaseOrderDetailQueryKey(
  purchaseOrderId: number,
): readonly ["mrp", "purchase-orders", "one", number] {
  return ["mrp", "purchase-orders", "one", purchaseOrderId];
}

export async function fetchPurchaseOrderDetail(
  purchaseOrderId: number,
): Promise<MrpPurchaseOrderDetailResponse> {
  return apiFetch<MrpPurchaseOrderDetailResponse>(`/api/mrp/purchase-orders/${String(purchaseOrderId)}`);
}

export function prefetchPurchaseOrderDetail(
  queryClient: { prefetchQuery: (options: unknown) => Promise<unknown> },
  purchaseOrderId: number,
): void {
  void queryClient.prefetchQuery({
    queryKey: purchaseOrderDetailQueryKey(purchaseOrderId),
    queryFn: () => fetchPurchaseOrderDetail(purchaseOrderId),
    staleTime: PURCHASE_ORDER_DETAIL_STALE_MS,
  });
}
